import { Component, Input } from '@angular/core';
import { ConnectionRight } from '@shared/interfaces/nts/connection-right';
import { TableComponent } from '@shared/components/table/table.component';
import { connectionRightHistoryTable } from '@shared/table-configs/connection-right/connection-right-history.table';

@Component({
  selector: 'app-connection-right-history',
  imports: [TableComponent],
  templateUrl: './connection-right-history.component.html',
})
export class ConnectionRightHistoryComponent {
  @Input() public connectionRights: ConnectionRight[] = [];

  public readonly tableConfig = connectionRightHistoryTable;
}
